import { reactive } from "vue";

export const enquiryState = reactive({
  currentEnquiryId: undefined,
});
